<template>
  <svg viewBox="0 0 22 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="#7B7B7B" fill-rule="nonzero">
      <path
        d="M21.931 6.733C19.547 2.868 15.751.107 11 0 6.25.107 2.453 2.868.069 6.733a.553.553 0 0 0 0 .534C2.399 11.061 6.286 14 11 14c4.714 0 8.602-2.939 10.931-6.733a.553.553 0 0 0 0-.534Zm-2.953 2.654a11.967 11.967 0 0 1-2.274 1.87c-1.706 1.087-3.668 1.692-5.704 1.692-1.944 0-3.852-.57-5.502-1.567a12.528 12.528 0 0 1-2.311-1.817c-.532-.534-1.816-1.639-1.908-2.37C1.096 5.7 4.14 3.474 5.278 2.744a10.92 10.92 0 0 1 5.704-1.692c1.962.053 3.833.552 5.502 1.567 1.174.713 4.218 2.886 4.218 4.382.019.748-1.228 1.888-1.724 2.387Z"
      />
      <ellipse cx="11" cy="6.611" rx="3.667" ry="3.5" />
    </g>
  </svg>
</template>
